<script setup lang="ts">
import StackLayout from '@/components/Layouts/StackLayout.vue'
import type { AdminOrganizationFiltersType } from '@/types/filters/AdminFilters'
import DebouncedInputField from '../../../../components/Fields/DebouncedInputField.vue'

type Props = {
    filters: AdminOrganizationFiltersType
}
defineProps<Props>()
type Emits = {
    (e: 'change', value: AdminOrganizationFiltersType): void
}
defineEmits<Emits>()
</script>

<template>
    <StackLayout :gap="8" class="full-width" isResponsiveSmallScreen>
        <DebouncedInputField
            :label="$t('user.filters.name')"
            :modelValue="filters.name"
            @change="$emit('change', { name: $event })" />
    </StackLayout>
</template>
